import theme from '../../base';

const tag = {
  background: theme.colors.neutrals.gray700,
  backgroundHover: theme.colors.neutrals.gray300,
  backgroundActive: theme.colors.neutrals.gray300,
  backgroundPrimary: theme.colors.primary.primary500,
  backgroundAlert: theme.colors.reds.red500,
  backgroundPositive: theme.colors.greens.green100,
  foreground: theme.colors.neutrals.white,
  foregroundActive: theme.colors.neutrals.gray800,
  foregroundHover: theme.colors.neutrals.gray800,
  foregroundAlert: theme.colors.neutrals.white,
  foregroundPrimary: theme.colors.neutrals.white,
  foregroundPositive: theme.colors.greens.green500,
};

export default tag;
